export default "__VITE_ASSET__b62eb41a__"